var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteOutline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.833 5.44h-.166a.164.164 0 0 0 .166-.16zh6.334v-.16c0 .088.075.16.166.16h-.166v1.44h1.5v-1.6c0-.706-.598-1.28-1.334-1.28H8.667c-.736 0-1.334.574-1.334 1.28v1.6h1.5zm10.5 1.44H4.667A.653.653 0 0 0 4 7.52v.64c0 .088.075.16.167.16h1.258l.515 10.46c.033.682.62 1.22 1.33 1.22h9.46c.712 0 1.297-.536 1.33-1.22l.515-10.46h1.258A.164.164 0 0 0 20 8.16v-.64a.653.653 0 0 0-.667-.64M16.57 18.56H7.43L6.927 8.32h10.146l-.504 10.24Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delete-outline.d532d4c2.svg";